import firebase from 'firebase/app';
if (firebase.apps.length === 0) {
    firebase.initializeApp(JSON.parse(process.env.VUE_APP_FIREBASE_CONFIG));
}
export default firebase;
